// import { Star, Quote } from 'lucide-react';
// import { useState } from 'react';

// const testimonials = [
//   {
//     id: 1,
//     name: 'Ahmed Benjelloun',
//     role: 'Buyer',
//     rating: 5,
//     text: 'Found my dream Mercedes in just 2 days! The verification process gave me confidence, and the seller was very professional. MORROCARS made the entire experience seamless.',
//     city: 'Casablanca',
//   },
//   {
//     id: 2,
//     name: 'Sara Alami',
//     role: 'Seller',
//     rating: 5,
//     text: 'Sold my car within a week at a great price. The platform is easy to use, and I received multiple serious inquiries. Highly recommend for anyone looking to sell.',
//     city: 'Rabat',
//   },
//   {
//     id: 3,
//     name: 'Youssef Tazi',
//     role: 'Dealer',
//     rating: 5,
//     text: 'As a dealer, MORROCARS has been invaluable for our business. The quality of leads is excellent, and the professional tools make managing our inventory simple.',
//     city: 'Marrakech',
//   },
// ];

// export function Testimonials() {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl sm:text-4xl text-[#2D323A] mb-4">
//             What Our Users Say
//           </h2>
//           <p className="text-lg text-[#717182]">
//             Join thousands of satisfied buyers and sellers
//           </p>
//         </div>

//         {/* Testimonials Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {testimonials.map((testimonial, index) => (
//             <div
//               key={testimonial.id}
//               className="bg-gradient-to-br from-[#F5F7FA] to-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-[#E5E7EB] relative"
//             >
//               {/* Quote Icon */}
//               <div className="absolute top-6 right-6 text-[#1E6DFF]/10">
//                 <Quote className="w-12 h-12" fill="currentColor" />
//               </div>

//               {/* Rating */}
//               <div className="flex gap-1 mb-4">
//                 {[...Array(testimonial.rating)].map((_, i) => (
//                   <Star
//                     key={i}
//                     className="w-5 h-5 text-[#F59E0B] fill-[#F59E0B]"
//                   />
//                 ))}
//               </div>

//               {/* Text */}
//               <p className="text-[#2D323A] leading-relaxed mb-6 relative z-10">
//                 "{testimonial.text}"
//               </p>

//               {/* Author */}
//               <div className="flex items-center gap-4">
//                 <div className="w-12 h-12 bg-gradient-to-br from-[#1E6DFF] to-[#1557d9] rounded-full flex items-center justify-center text-white text-lg">
//                   {testimonial.name.charAt(0)}
//                 </div>
//                 <div>
//                   <div className="text-[#2D323A]">{testimonial.name}</div>
//                   <div className="text-sm text-[#717182]">
//                     {testimonial.role} • {testimonial.city}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Mobile Dots Navigation */}
//         <div className="flex justify-center gap-2 mt-8 md:hidden">
//           {testimonials.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentIndex(index)}
//               className={`w-2 h-2 rounded-full transition-all ${
//                 index === currentIndex ? 'bg-[#1E6DFF] w-8' : 'bg-[#E5E7EB]'
//               }`}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }
// src/components/Testimonials.jsx
import { Star, Quote } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCms } from '../hooks/useCms';

export function Testimonials() {
  const { t } = useTranslation('home');
  const { get } = useCms('home');
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: get('testimonials.testimonial1Name', 'Ahmed Benjelloun'),
      role: get('testimonials.testimonial1Role', t('testimonials.buyer')),
      rating: 5,
      text: get('testimonials.testimonial1', 'Found my dream Mercedes in just 2 days! The verification process gave me confidence, and the seller was very professional. MORROCARS made the entire experience seamless.'),
      city: get('testimonials.testimonial1City', 'Casablanca'),
    },
    {
      id: 2,
      name: get('testimonials.testimonial2Name', 'Sara Alami'),
      role: get('testimonials.testimonial2Role', t('testimonials.seller')),
      rating: 5,
      text: get('testimonials.testimonial2', 'Sold my car within a week at a great price. The platform is easy to use, and I received multiple serious inquiries. Highly recommend for anyone looking to sell.'),
      city: get('testimonials.testimonial2City', 'Rabat'),
    },
    {
      id: 3,
      name: get('testimonials.testimonial3Name', 'Youssef Tazi'),
      role: get('testimonials.testimonial3Role', t('testimonials.dealer')),
      rating: 5,
      text: get('testimonials.testimonial3', 'As a dealer, MORROCARS has been invaluable for our business. The quality of leads is excellent, and the professional tools make managing our inventory simple.'),
      city: get('testimonials.testimonial3City', 'Marrakech'),
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl text-[#2D323A] mb-4">
            {get('testimonials.testimonialTitle', t('testimonials.title'))}
          </h2>
          <p className="text-lg text-[#717182]">
            {get('testimonials.testimonialDescription', t('testimonials.subtitle'))}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-gradient-to-br from-[#F5F7FA] to-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-[#E5E7EB] relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-[#1E6DFF]/10">
                <Quote className="w-12 h-12" fill="currentColor" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 text-[#F59E0B] fill-[#F59E0B]"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-[#2D323A] leading-relaxed mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1E6DFF] to-[#1557d9] rounded-full flex items-center justify-center text-white text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <div className="text-[#2D323A]">{testimonial.name}</div>
                  <div className="text-sm text-[#717182]">
                    {testimonial.role} • {testimonial.city}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Dots Navigation */}
        <div className="flex justify-center gap-2 mt-8 md:hidden">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentIndex ? 'bg-[#1E6DFF] w-8' : 'bg-[#E5E7EB]'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
